import { render, staticRenderFns } from "./StartScreenShareSupport.vue?vue&type=template&id=3149339e&"
import script from "./StartScreenShareSupport.vue?vue&type=script&lang=js&"
export * from "./StartScreenShareSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports